// app
export const HOME = "/home";
export const LOGIN = "/login";
export const CHANGE_PASSWORD = "/change_password";
export const LOGOUT = "/logout";
export const OTPVERIFICATION = "/otpverification";
//
export const TEST_SCREEN = "/test-screen";
export const USER_MANAGEMENT = "/user-management";
export const ADMIN_PANEL_USER_MANAGEMENT = "/user-management/admin-panel-users";
export const MOBILE_APP_USER_MANAGEMENT = "/user-management/mobile-app-users";
export const USER_DETAILS = "/mobile-app-users/user-details"; //includes url params
export const YOUTUBE_MANAGEMENT = "/media/youtube-management";
export const CONTENT_DETAIL = "/media/content-detail/youtube";
export const INSTAGRAM_MANAGEMENT = "/media/instagram-management";
export const BANNER_MANAGEMENT = "/media/banner-management";
export const ADD_BANNER = "/media/add-banner";
export const EDIT_BANNER = "/media/edit-banner";
export const NOTIFICATION_MANAGEMENT = "/media/notification-management";
export const ADD_NOTIFICATION =
  "/media/notification-management/add-notification";
export const EDIT_NOTIFICATION =
  "/media/notification-management/edit-notification";
export const TRANSACTION_HISTORY = "/subscription/transaction-history";
export const SEND_NOTIFICATION_TO_USERS =
  "/media/notification-management/send-notifications"; //includes url params
export const NOTIFICATION_ACTIVITY_LOG =
  "/media/notification-management/activity-log";
export const MOBILE_USER_ACTIVITY_LOG =
  "/user-management/mobile-app-users/user-activity-log"; //includes url params
export const MOBILE_USER_ACTIVITY_LOG_DETAILS =
  "/user-management/mobile-app-users/user-activity-log/log-details"; //includes url params
